import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import { TableContainer, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MAP_TO_PLAYER, MAKE_AND_MAP_PLAYER } from '../../hasura/queries/player/playerMapping';
import { ClaimFilters } from '../../components/claim/claimFilters';
import { EntityLinkTable } from '../table/entityLinkTable';
import { PLAYER_CLAIM_TO_MAP_SCHEMA } from '../../schema/playerSchema';
import { RepeatableError } from '../util/notifications';
import { mutationError } from '../graphql/util';
import ClaimMappingButtons from '../mapping/claimMappingButtons';
import { SIMILAR_PLAYERS } from '../../hasura/queries/player/playerList';
import { SimilarEntity } from '../mapping/SimilarEntity';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3),

    '& h3': {
      paddingLeft: 5,
    },
    '& button': {
      margin: '10px 5px',
      float: 'right',
    },
    '& tr': {
      cursor: 'pointer',
      '&.active': {
        backgroundColor: theme.palette.secondary.dark,
      },
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
      },
    },
  },
}));
const PlayerMapping = props => {
  const classes = useStyles();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState(null);
  const [playerMapViewState, setPlayerMapViewState] = useState({
    claimFilter: 'all',
    selectedClaim: null,
    selectedSim: null,
  });

  const filterResults = claimFilter => {
    setPlayerMapViewState({
      ...playerMapViewState,
      claimFilter,
    });
  };

  const filterClaims = claims => {
    if (playerMapViewState.claimFilter === 'undecided') {
      return claims.filter(c => c.approved_at === null && c.rejected_at === null);
    } else if (playerMapViewState.claimFilter === 'approved') {
      return claims.filter(c => c.approved_at != null);
    } else if (playerMapViewState.claimFilter === 'rejected') {
      return claims.filter(c => c.rejected_at != null);
    } else {
      return claims;
    }
  };

  const selectClaim = selectedClaim => {
    setPlayerMapViewState({
      ...playerMapViewState,
      selectedClaim,
    });
  };

  const selectSimilarPlayer = selectedSim => {
    setPlayerMapViewState({
      ...playerMapViewState,
      selectedSim,
    });
  };

  const filteredClaims = filterClaims(props.claims);

  const returnToClaimsList = () => {
    history.push('/claims/player');
  };

  const [mapToPlayer] = useMutation(MAP_TO_PLAYER, {
    onError: err => setErrorMessage(mutationError(err, 'Problem Mapping Player Claim to Statsbomb Player')),
    onCompleted: returnToClaimsList,
  });

  const [makeAndMapPlayer] = useMutation(MAKE_AND_MAP_PLAYER, {
    onError: err => setErrorMessage(mutationError(err, 'Problem Mapping Player Claim to Statsbomb Player')),
    onCompleted: returnToClaimsList,
  });

  const selClaim = props.claims.filter(c => c.claim_player_uuid === playerMapViewState.selectedClaim)[0] || {};

  const createPlayerMapFn = async e => {
    e.preventDefault();
    try {
      await mapToPlayer({
        variables: {
          player_id: playerMapViewState.selectedSim,
          provider: selClaim.provider,
          provider_player_id: selClaim.provider_player_id,
        },
      });
    } catch (err) {
      console.error({ 'mapping failed': err });
    }
  };

  const createPlayerAndMapFn = async e => {
    e.preventDefault();
    try {
      await makeAndMapPlayer({
        variables: {
          player_name: selClaim.player_name,
          provider: selClaim.provider,
          provider_player_id: selClaim.provider_player_id,
        },
      });
    } catch (err) {
      console.error({ 'mapping failed': err });
    }
  };

  return (
    <>
      <div className="container-row">
        <h2>Unmapped Player Mapper. Provider Player Id: {props.provider_player_id}</h2>
        <h3>Select A Claim to view Possible Players</h3>
        <TableContainer component={Paper}>
          <ClaimFilters claimFilter={playerMapViewState.claimFilter} filterResultsFn={filterResults} />

          <EntityLinkTable
            entities={filteredClaims}
            schema={PLAYER_CLAIM_TO_MAP_SCHEMA}
            rowClickHandler={claim => {
              selectClaim(claim.claim_player_uuid);
            }}
            entityKey="claim_player_uuid"
            selectedEntityKey={playerMapViewState?.selectedClaim}
          />
        </TableContainer>

        {playerMapViewState.selectedClaim && (
          <TableContainer component={Paper} classes={classes}>
            <SimilarEntity
              provider="Soccerway"
              entityName={selClaim.player_name}
              selectSimilarEntityFn={selectSimilarPlayer}
              selectedSim={playerMapViewState.selectedSim}
              type="player"
              query={SIMILAR_PLAYERS}
            />

            <ClaimMappingButtons
              displayName="Player"
              claim={selClaim}
              similarRecord={playerMapViewState.selectedSim}
              schema={[]}
              mapEntityFn={createPlayerMapFn}
              createNewEntityFn={createPlayerAndMapFn}
            />
          </TableContainer>
        )}
      </div>
      <RepeatableError message={errorMessage} setMessage={setErrorMessage} />
    </>
  );
};

export { PlayerMapping };
